export function convertToURLFormat(inputString: string) {
    // Remove special characters and strip accents
    let urlFriendlyString = inputString.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    // Replace non-alphanumeric characters with hyphens
    urlFriendlyString = urlFriendlyString.replace(/[^a-zA-Z0-9]/g, '-');
    // Remove any leading or trailing hyphens
    urlFriendlyString = urlFriendlyString.replace(/^-+|-+$/g, '');
    // Convert to lowercase
    return urlFriendlyString.toLowerCase();
}